import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FORMNAMES, setBrowserTitle } from '../utilities/codes';
import { getFormEntriesByFormName } from '../services/formServices';
import { mediaSource } from '../utilities/mediautilities';
import { loaderContext } from '../contexts/LoaderProvider';
import toast from 'react-hot-toast';
import NotFound from './NotFound';
import Breadcrumb from '../components/Breadcrumb';
import { I18N_KEYS } from '../languages/PlaceHolder';
import { useTranslation } from 'react-i18next';

const DynamicPage = () => {
    const { setIsLoading } = useContext(loaderContext);
    const [pageDetail, setPageDetail] = useState({});
    const { slug } = useParams();
    const { t } = useTranslation()

    useEffect(() => {
        if (slug && setIsLoading) {
            const getPageDetail = async () => {
                try {
                    setIsLoading(true);
                    const filter = {
                        publish: { operator: "equals", value: true },
                        slug: { operator: "equals", value: slug },
                    };

                    const page = await getFormEntriesByFormName(
                        FORMNAMES.DYANAMICFORM,
                        filter,
                        { page: 1, limit: 1 }
                    );
                    setPageDetail(page?.[0]?.payload);
                } catch (error) {
                    toast.error(error?.message);
                } finally {
                    setIsLoading(false);
                }
            };
            getPageDetail();
        }
    }, [slug, setIsLoading]);

    useEffect(() => {
        if (pageDetail?.title) {
            setBrowserTitle(`${pageDetail?.title} - ${pageDetail?.category}`)
            return
        }
        setBrowserTitle(`Pages`)
    }, [pageDetail])

    if (!pageDetail) return <NotFound />

    return (
        <>
            <Breadcrumb pageDetail={pageDetail} />
            {pageDetail &&
                (!pageDetail?.header_title && !pageDetail?.subtitle && !pageDetail?.page_content) ?
                (<>
                    <div className="min-h-[60vh] flex items-center justify-center px-6">
                        <div className="max-w-xl text-center bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-sm">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                                {t(I18N_KEYS.DYNAMICPAGETITLE)}
                            </h2>
                            <p className="text-gray-600 leading-relaxed mb-6">
                                {t(I18N_KEYS.DYANAMICPAGEDES)}
                            </p>
                            <a
                                href="/"
                                className="inline-flex items-center justify-center rounded-lg bg-primary px-6 py-2.5 text-white font-medium hover:bg-primary/90 transition"
                            >
                                {t(I18N_KEYS.GOTO)} {t(I18N_KEYS.HOMEPAGENAME)}
                            </a>
                        </div>
                    </div>
                </>)
                : (<> <article className="bg-white">
                    {pageDetail?.bg_image?.fileUrl &&
                        (<section className="relative bg-cover bg-center py-36 px-6">
                            <img
                                src={mediaSource(pageDetail?.bg_image?.fileUrl)}
                                alt={pageDetail?.header_title || "Page banner"}
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                        </section>)}


                    <header className="common-container mx-auto px-6 pt-16 pb-10 text-center">
                        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-primary mb-4">
                            {pageDetail?.header_title}
                        </h1>

                        {pageDetail?.subtitle && (
                            <p className="text-lg md:text-xl text-primary leading-relaxed">
                                {pageDetail?.subtitle}
                            </p>
                        )}
                    </header>
                    <section className="common-container mx-auto px-6 pb-20">
                        <div className="prose prose-lg prose-gray max-w-none sm:max-w-600 leading-relaxed ck-content">
                            <p className="text-gray-600"
                                dangerouslySetInnerHTML={{ __html: pageDetail?.page_content }}
                            ></p>
                        </div>
                    </section>
                </article></>)

            }

        </>
    );
}
export default DynamicPage;